//import {Link, BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'universal-cookie/es6';
import apis from '../../api';
import { Div, Form, FormGroup, Forms, Label } from './Payroll.styles';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Payroll.css'
import useWindowDimensions from '../hooks/useDimensions';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Payroll
Description : Configuración de la nómina de una empresa.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
03/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

export default function Payroll(props) {

    var _ = require('lodash');//Para comparar objetos json

    /*Propiedades del componente*/
    const [ausentismos, setAusentimos] = useState("");
    const [tipoPagoEnfermedad, setTipoPagoEnfermedad] = useState("");
    const [vacaciones, setVacaciones] = useState("");
    const [variableVacaciones, setVariableVacaciones] = useState("");
    const [pagoSubsidioTransporte, setPagoSubsidioTransporte] = useState("");
    const [extraSubsidioTransporte, setExtraSubsidioTransporte] = useState("");
    const [slnPrima, setSlnPrima] = useState("");
    const [auxilioTransporte, setAuxilioTransporte] = useState("");
    const [primaJunio, setPrimaJunio] = useState("");
    const [primaDiciembre, setPrimaDiciembre] = useState("");
    const [interesesCesantias, setInteresesCesantias] = useState("");
    const [auxilioCesantias, setAuxilioCesantias] = useState("");
    const [nomina, setNomina] = useState("");
    const [cotizacion, setCotizacion] = useState("");
    const [nominaElectronica, setNominaElectronica] = useState("")
    const [solidaridad, setSolidaridad] = useState("")
    const [retefuente, setRetefuente] = useState("")

    /*Listas de valores del componente*/
    const [listaAusentismos, setListaAusentismos] = useState([]);
    const [listaTipoPagoEnfermedad, setListaTipoPagoEnfermedad] = useState([]);
    const [listaVacaciones, setListaVacaciones] = useState([]);
    const [listaVariableVacaciones, setListaVariableVacaciones] = useState([]);
    const [listaSlnPrima, setListaSlnPrima] = useState([]);
    const [listaAuxilioTransporte, setListaAuxilioTransporte] = useState([]);
    const [listaPrimaJunio, setListaPrimaJunio] = useState([]);
    const [listaPrimaDiciembre, setListaPrimaDiciembre] = useState([]);
    const [listaInteresesCesantias, setListaInteresesCesantias] = useState([]);
    const [listaAuxilioCesantias, setListaAuxilioCesantias] = useState([]);
    const [listaPagoSubsidioTransporte, setListaPagoSubsidioTransporte] = useState([]);
    const [listaExtraSubsidioTransporte, setListaExtraSubsidioTransporte] = useState([]);
    const [listaCotizacion, setListaCotizacion] = useState([]);
    const [listaNominaElectronica, setListaNominaElectronica] = useState([]);
    const [listaSolidaridad, setListaSolidaridad] = useState([])
    const [listaRetefuente, setListaRetefuente] = useState([])

    const [rowId, setRowId] = useState(0);

    /*Propiedades de los modales del componente*/
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loadPage, setLoadPage] = useState(false)

    /*Mensajes informativos*/
    const { info } = useInfo("Payroll");

    /*Constantes globales para el componente*/
    const headers = { Authorization: localStorage.getItem("token") }
    /*Si el cliente no tiene habilitada la configuración de nómina (conf_nom = N), el formulario es solo lectura*/
    const canEditConf = localStorage.getItem('conf_nom') !== 'N'
    const elementWidth = { borderRadius: "10px" };
    const cardStyle = {
        width: "100%", marginBottom: "1rem", justifyContent: "center",
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }
    const toast = useRef(null);
    const { width } = useWindowDimensions()

    useEffect(() => {
        const getLists = async () => {
            if (localStorage.getItem('client') != null) {
                /*Se cargan los datos de las listas de valores del componente*/
                await apis.getValueListPayrollConf(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                    let confAbs = res.data["CONF_ABS"]
                    let confPreLey = res.data["CONF_PRE_LEY"]
                    let confTran = res.data["CONF_TRAN"]
                    let confVac = res.data["CONF_VAC"]
                    let confAfp = res.data["CONF_AFP_SLN"]
                    let confDes = res.data["CONF_DES_LEY"]

                    let contenidoAusentismos = confAbs[0]["PAGA_DIA_31"]
                    let contenidoTipoPagoEnfermedad = confAbs[0]["LITE_ABS_EG"]
                    let contenidoVacaciones = confVac[0]["PAGA_DIA_31"]
                    let contenidoVariableVacaciones = confVac[0]["VARIABLE"]
                    let contenidoSlnPrima = confPreLey[0]["CONF_PRIMA"][0]["APLICA_LNR"]
                    let contenidoAuxilioTransporte = confPreLey[0]["CONF_PRIMA"][0]["AUX_TRANS"]
                    let contenidoPrimaJunio = confPreLey[0]["CONF_PRIMA"][0]["PRIM_PAG_JUNE"][0]["LITE_PRIM_PAG"]
                    let contenidoPrimaDiciembre = confPreLey[0]["CONF_PRIMA"][0]["PRIM_PAG_DECEMBER"][0]["LITE_PRIM_PAG"]
                    let contenidoInteresesCesantias = confPreLey[0]["CONF_INTER"][0]["LITE_INT_CESA_PAG"]
                    let contenidoAuxilioCesantias = confPreLey[0]["CONF_CESA"][0]["AUX_TRANS"]
                    //let contenidoExtraSubsidioTransporte = confTran[0]["CONCEPTS"]
                    let contenidoPagoSubsidioTransporte = confTran[0]["LITE_SUB_TRS_PAG"]
                    let contenidoNominaElectronica = confPreLey[0]["CONF_NE"][0]["CONF_NE_PRE_LEY"]
                    let contenidoSolidaridad = confDes[0]['LITE_SOLID_PAG']
                    let contenidoRetefuente = confDes[1]['LITE_RETE_PAG']

                    setListaAusentismos(contenidoAusentismos)
                    setListaTipoPagoEnfermedad(contenidoTipoPagoEnfermedad)
                    setListaVacaciones(contenidoVacaciones)
                    setListaVariableVacaciones(contenidoVariableVacaciones)
                    setListaSlnPrima(contenidoSlnPrima)
                    setListaAuxilioTransporte(contenidoAuxilioTransporte)
                    setListaPrimaJunio(contenidoPrimaJunio)
                    setListaPrimaDiciembre(contenidoPrimaDiciembre)
                    setListaInteresesCesantias(contenidoInteresesCesantias)
                    setListaAuxilioCesantias(contenidoAuxilioCesantias)
                    //setListaExtraSubsidioTransporte(contenidoExtraSubsidioTransporte)
                    setListaPagoSubsidioTransporte(contenidoPagoSubsidioTransporte)
                    setListaCotizacion(confAfp)
                    setListaNominaElectronica(contenidoNominaElectronica)
                    setListaSolidaridad(contenidoSolidaridad)
                    setListaRetefuente(contenidoRetefuente)
                })
            }
            setTabla()
        }
        getLists()
    }, [rowId])

    useEffect(() => {
        const getConcepts = async () => {
            /*Se cargan los datos de la lista de valores de conceptos*/
            await apis.getConceptsPayrollConf(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let conceptos = res.data["CONCEPTS"]
                ////console.log(conceptos)
                setListaExtraSubsidioTransporte(conceptos)
            })
        }
        getConcepts()
    }, [rowData, rows, rowId])

    useEffect(() => {
        /*Si la npomina está configurada, se encarga su información*/
        loadPayrollInformation()
    }, [])

    async function loadPayrollInformation() {
        if (localStorage.getItem('client') != null) {
            try {
                await apis.getPayrollConf(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                    if (res.data["CONCEPTS"] != []) {
                        let confAbs = res.data["CONF_ABS"]
                        let confPreLey = res.data["CONF_PRE_LEY"]
                        let confTran = res.data["CONF_TRAN"]
                        let confVac = res.data["CONF_VAC"]
                        let confAfp = res.data["CONF_AFP_SLN"].split("|")
                        let confDes = res.data["CONF_DES_LEY"]
                        let defaultAusentismos = confAbs[0]["PAGA_DIA_31"].split("|")
                        let defaultTipoPagoEnfermedad = confAbs[1]["LITE_ABS_EG"].split("|")
                        let defaultVacaciones = confVac[1]["PAGA_DIA_31"].split("|")
                        let defaultVariablesVacaciones = confVac[0]["VARIABLE"].split("|")
                        let defaultSlnPrima = confPreLey[0]["CONF_PRIMA"][1]["APLICA_LNR"].split("|")
                        let defaultAuxilioTransporte = confPreLey[0]["CONF_PRIMA"][0]["AUX_TRANS"].split("|")
                        let defaultInteresesCesantias = confPreLey[2]["CONF_INTER"][0]["LITE_INT_CESA_PAG"].split("|")
                        let defaultAuxilioCesantias = confPreLey[1]["CONF_CESA"][0]["AUX_TRANS"].split("|")
                        let defaultPagoSubsidioTransporte = confTran[0]["LITE_SUB_TRS_PAG"].split("|")

                        let defaultPrimaJunio = confPreLey[0]["CONF_PRIMA"][2]["PRIM_PAG_JUNE"][0]["LITE_PRIM_PAG"]
                        let defaultPrimaDiciembre = confPreLey[0]["CONF_PRIMA"][3]["PRIM_PAG_DECEMBER"][0]["LITE_PRIM_PAG"]
                        let defaultNominaElectronica = confPreLey[3]["CONF_NE"][0]["CONF_NE_PRE_LEY"] ? confPreLey[3]["CONF_NE"][0]["CONF_NE_PRE_LEY"] : ""

                        let defaultSolidaridad = confDes[0]["LITE_SOLID_PAG"].split('|')
                        let defaultRetefuente = confDes[1]["LITE_RETE_PAG"].split('|')

                        if (defaultPrimaJunio !== "" && defaultPrimaJunio !== undefined) {
                            defaultPrimaJunio = defaultPrimaJunio.split("|")
                        }
                        else {
                            defaultPrimaJunio = ["", ""]
                        }

                        if (defaultPrimaDiciembre !== "" && defaultPrimaDiciembre !== undefined) {
                            defaultPrimaDiciembre = defaultPrimaDiciembre.split("|")
                        }
                        else {
                            defaultPrimaDiciembre = ["", ""]
                        }

                        if (defaultNominaElectronica !== "" && defaultNominaElectronica !== undefined) {
                            defaultNominaElectronica = defaultNominaElectronica.split("|")
                        }
                        else {
                            defaultNominaElectronica = ["", ""]
                        }

                        let defaultNomina = {
                            CLIENT: localStorage.getItem('client'),
                            ENTITY: localStorage.getItem('entity'),
                            CONF_AFP_SLN: confAfp[0],
                            CONF_ABS: [
                                {
                                    PAGA_DIA_31: defaultAusentismos[0],
                                },
                                {
                                    LITE_ABS_EG: defaultTipoPagoEnfermedad[0]
                                }
                            ],
                            CONF_VAC: [
                                {
                                    VARIABLE: defaultVariablesVacaciones[0]
                                },
                                {
                                    PAGA_DIA_31: defaultVacaciones[0]
                                }
                            ],
                            CONF_TRAN: [
                                {
                                    LITE_SUB_TRS_PAG: defaultPagoSubsidioTransporte[0]
                                }
                            ],
                            CONF_PRE_LEY: [
                                {
                                    CONF_PRIMA: [
                                        {
                                            AUX_TRANS: defaultAuxilioTransporte[0]
                                        },
                                        {
                                            APLICA_LNR: defaultSlnPrima[0]
                                        },
                                        {
                                            PRIM_PAG_JUNE: [
                                                {
                                                    LITE_PRIM_PAG: defaultPrimaJunio[0]
                                                }
                                            ]
                                        },
                                        {
                                            PRIM_PAG_DECEMBER: [
                                                {
                                                    LITE_PRIM_PAG: defaultPrimaDiciembre[0]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    CONF_CESA: [
                                        {
                                            AUX_TRANS: defaultAuxilioCesantias[0]
                                        }
                                    ]
                                },
                                {
                                    CONF_INTER: [
                                        {
                                            LITE_INT_CESA_PAG: defaultInteresesCesantias[0]
                                        }
                                    ]
                                },
                                {
                                    CONF_NE: [
                                        {
                                            CONF_NE_PRE_LEY: defaultNominaElectronica[0]
                                        }
                                    ]
                                },
                                {
                                    CONF_DES_LEY: [
                                        {
                                            LITE_SOLID_PAG: defaultSolidaridad[0]
                                        },
                                        {
                                            LITE_RETE_PAG: defaultRetefuente[0]
                                        }
                                    ]
                                }
                            ]
                        }
                        setNomina(defaultNomina)
                        setCotizacion({ detail_id: confAfp[0], description: confAfp[1] })
                        setAusentimos({ detailId: defaultAusentismos[0], description: defaultAusentismos[1] })
                        setTipoPagoEnfermedad({ detail_id: defaultTipoPagoEnfermedad[0], description: defaultTipoPagoEnfermedad[1] })
                        setVacaciones({ detailId: defaultVacaciones[0], description: defaultVacaciones[1] })
                        setVariableVacaciones({ detailId: defaultVariablesVacaciones[0], description: defaultVariablesVacaciones[1] })
                        setSlnPrima({ detailId: defaultSlnPrima[0], description: defaultSlnPrima[1] })
                        setAuxilioTransporte({ detailId: defaultAuxilioTransporte[0], description: defaultAuxilioTransporte[1] })
                        setPrimaJunio({ detail_id: defaultPrimaJunio[0], description: defaultPrimaJunio[1] })
                        setPrimaDiciembre({ detail_id: defaultPrimaDiciembre[0], description: defaultPrimaDiciembre[1] })
                        setInteresesCesantias({ detail_id: defaultInteresesCesantias[0], description: defaultInteresesCesantias[1] })
                        setAuxilioCesantias({ detailId: defaultAuxilioCesantias[0], description: defaultAuxilioCesantias[1] })
                        setPagoSubsidioTransporte({ detail_id: defaultPagoSubsidioTransporte[0], description: defaultPagoSubsidioTransporte[1] })
                        setNominaElectronica({ detail_id: defaultNominaElectronica[0], description: defaultNominaElectronica[1] })
                        setSolidaridad({ detail_id: defaultSolidaridad[0], description: defaultSolidaridad[1] })
                        setRetefuente({ detail_id: defaultRetefuente[0], description: defaultRetefuente[1] })
                    }
                })
            }
            catch (err) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
            }
        }
    }

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
                    <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const leftToolbarTemplate = () => {
        return (
            <div className='tab'>
                <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModal()} />
                <span style={{ fontWeight: "bold" }}>Indicar los conceptos base para validar el tope de ley</span>
            </div>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar horas extra" tooltipOptions={{ position: 'top' }} onClick={() => { setExtraSubsidioTransporte(rowData["CONCEPT"]); showModalEliminar() }} />
            </div>
        )
    }

    const renderHeader1 = () => {
        return (
            <div className="sb">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave"
                        style={{
                            width: "100%"
                        }}
                    />
                </IconField>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONCEPT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    /*Funciones que manejan el comportamiento de los modales del componente*/
    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        //console.log("Zi")
        setIsOpen(false);
        //limpiar();
    };

    const showModalEliminar = () => {
        setIsOpenEliminar(true);
    };

    const hideModalEliminar = () => {
        setIsOpenEliminar(false)
    };

    const didNotUpdate = () => {
        /*Función encargada de mostrar un mensaje si no hubieron cambios en la configuración de la nómina*/
        setLoading3(false)
        toast.current.show({
            severity: 'info', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-info-circle" style={{ fontSize: '3rem', color: "blue" }}></i>
                        <p>Nada por actualizar</p>
                    </div>
                    <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <div className="col-6">
                            <a style={{ textDecoration: 'none' }}>
                                <Button type="button" label="Cerrar" className="p-button-danger" onClick={() => toast.current.clear()} />
                            </a>
                        </div>
                    </div>
                </div>
            )
        });
    }

    function validateForm() {
        /*Función que valida el valor de los campos de entrada del componente*/
        return ausentismos != "" && tipoPagoEnfermedad != "" && vacaciones != "" &&
            variableVacaciones != "" && pagoSubsidioTransporte != "" &&
            slnPrima != "" && auxilioTransporte != "" && primaJunio != "" && primaDiciembre != "" &&
            interesesCesantias != "";
    }

    function handleSubmit(event) {
        event.preventDefault();
    }

    async function setTabla() {
        /*Función encargada de cargar la información de la tabla del componente*/
        try {
            await apis.getPayrollGroupConf(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
                if (res.data["CONCEPTS"].length > 0) {
                    let data = res.data["CONCEPTS"]
                    let contenidoTabla = []
                    data.forEach(element => {
                        contenidoTabla.push({ CONCEPT: element.CODE, NAME: element.NAME, TYPE: element.TYPE })
                    })
                    setRows(contenidoTabla)
                    setRowData(contenidoTabla)
                    setLoadPage(true)
                }
                else {
                    setRows([])
                    setRowData([])
                    setLoadPage(true)
                }
            })
        }
        catch (err) {
            setLoadPage(true)
        }
    }

    async function postPayrollConcept() {
        /*Función encargada de guardar el concepto de nómina en la base de datos*/
        const _cliente = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const _concepto = extraSubsidioTransporte.CODE
        const _idGroup = "NULL"

        const companyPayrollGroup = {
            CLIENT: _cliente,
            ENTITY: _entity,
            IDGROUP: _idGroup,
            CONCEPT: _concepto
        }

        try {
            await apis.postPayrollGroupConf(companyPayrollGroup, headers).then(res => {
                setLoading1(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Concepto de nómina agregado exitosamente' });
            })
            setTabla();
            hideModal();
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putPayroll() {
        /*Función encargada de actualizar la información de la configuración de la nómina*/
        if (!canEditConf) {
            setLoading3(false)
            return
        }
        const _cliente = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const _ausentismos = ausentismos.detailId
        const _tipoPagoEnfermedad = tipoPagoEnfermedad.detail_id
        const _vaciones = vacaciones.detailId
        const _variableVacaciones = variableVacaciones.detailId
        const _slnPrima = slnPrima.detailId
        const _auxilioTransporte = auxilioTransporte.detailId
        const _primaJunio = primaJunio.detail_id
        const _primaDiciembre = primaDiciembre.detail_id
        const _interesesCesantias = interesesCesantias.detail_id
        const _auxilioCesantias = auxilioCesantias.detailId
        const _pagoSubsidioTransporte = pagoSubsidioTransporte.detail_id
        const _cotizacion = cotizacion.detail_id
        const _nominaElectronica = nominaElectronica.detail_id
        const _solidaridad = solidaridad.detail_id
        const _retefuente = retefuente.detail_id

        const companyPayroll = {
            CLIENT: _cliente,
            ENTITY: _entity,
            CONF_AFP_SLN: _cotizacion,
            CONF_ABS: [
                {
                    PAGA_DIA_31: _ausentismos
                },
                {
                    LITE_ABS_EG: _tipoPagoEnfermedad
                }
            ],
            CONF_VAC: [
                {
                    VARIABLE: _variableVacaciones
                },
                {
                    PAGA_DIA_31: _vaciones
                }
            ],
            CONF_TRAN: [
                {
                    LITE_SUB_TRS_PAG: _pagoSubsidioTransporte
                }
            ],
            CONF_PRE_LEY: [
                {
                    CONF_PRIMA: [
                        {
                            AUX_TRANS: _auxilioTransporte
                        },
                        {
                            APLICA_LNR: _slnPrima
                        },
                        {
                            PRIM_PAG_JUNE: [
                                {
                                    LITE_PRIM_PAG: _primaJunio
                                }
                            ]
                        },
                        {
                            PRIM_PAG_DECEMBER: [
                                {
                                    LITE_PRIM_PAG: _primaDiciembre
                                }
                            ]
                        }
                    ]
                },
                {
                    CONF_CESA: [
                        {
                            AUX_TRANS: _auxilioCesantias
                        }
                    ]
                },
                {
                    CONF_INTER: [
                        {
                            LITE_INT_CESA_PAG: _interesesCesantias
                        }
                    ]
                },
                {
                    CONF_NE: [
                        {
                            CONF_NE_PRE_LEY: _nominaElectronica
                        }
                    ]
                },
                {
                    CONF_DES_LEY: [
                        {
                            LITE_SOLID_PAG: _solidaridad
                        },
                        {
                            LITE_RETE_PAG: _retefuente
                        }
                    ]
                }
            ]
        }
        if (_.isEqual(companyPayroll, nomina)) {
            didNotUpdate()
            setLoading3(false)
        }
        else {
            try {
                await apis.putPayrollConf(companyPayroll, headers).then(res => {
                    setLoading3(false)
                    loadPayrollInformation()
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Configuración de nómina actualizada exitosamente' });
                })
            }
            catch (err) {
                setLoading3(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }
    }

    async function deletePayrollConcept() {

        /*Función encargada de eliminar el concepto de nómina de la base de datos*/
        const _cliente = localStorage.getItem('client');
        const _entity = localStorage.getItem('entity')
        const _concepto = extraSubsidioTransporte
        const _idGroup = "NULL"

        try {
            await apis.deletePayrollGroupConf(_entity, _cliente, _idGroup, _concepto, headers).then(res => {
                setLoading2(false)
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'Concepto de nómiona eliminado exitosamente' });
            })
            setTabla();
            hideModalEliminar();
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
        }
    }

    /*Headers y footers de los modales del componente*/
    const addFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); postPayrollConcept() }} />
        </div>
    );

    const addHeader = (
        <div>
            <h3>Agregar concepto</h3>
        </div>
    )

    const deleteFooter = (
        <div>
            <Button onClick={() => { setLoading2(false); hideModalEliminar() }}>Cancelar</Button>
            <Button label="Si" loading={loading2} onClick={() => { setLoading2(true); deletePayrollConcept() }} />
        </div>
    );

    const deleteHeader = (
        <div>
            <h3>¿Desea eliminar el concepto?</h3>
        </div>
    )

    /*Renderizado del componente*/
    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} />
            <Dialog header={addHeader} footer={addFooter} visible={isOpen}
                position="top" className='dialog' draggable={false} resizable={false} modal onHide={hideModal}>
                <Label htmlFor="label">Concepto</Label>
                <InfoIcon msg={info[11]}
                    element={
                        <Dropdown className="dd" value={extraSubsidioTransporte} autoFocus
                            tooltip={extraSubsidioTransporte?.NAME} tooltipOptions={{ position: 'top' }}
                            filter showClear filterBy="NAME" emptyMessage={"No hay conceptos disponibles"}
                            options={listaExtraSubsidioTransporte} placeholder={"Seleccione el concepto"}
                            onChange={(e) => {
                                //console.log(e.value)
                                setExtraSubsidioTransporte(e.value)
                            }}
                            optionLabel='NAME'
                        />
                    }
                />
            </Dialog>
            <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
                position="top" className='dialog' draggable={false} resizable={false} modal onHide={hideModalEliminar}>
            </Dialog>
            <Form onSubmit={handleSubmit}>
                <Tooltip target=".info" className='indigo-tooltip ml-1' />
                <div className="flex flex-row align-items-center justify-content-center font-bold text-4xl mt-5 mb-3">
                    <span className="text-900">Configuración de nómina</span>
                    <Video header="Instructivo proceso configuración de nómina" url={localStorage.getItem('PAYROLL_VIDEO')} />
                </div>
                <SkeletonTable load={loadPage} width="80vw">
                    <div className='flex justify-content-center'>
                        <Tooltip target=".info" className='indigo-tooltip ml-1' />
                        <Forms className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5 mb-3">
                            <Card title="Configuración ausentismos" style={cardStyle}>
                                <Div className='mt-5'>
                                    <FormGroup style={{
                                        marginTop: width > 961 ? "-4.5rem" : '-3rem',
                                        marginBottom: (width < 813 && width > 453 && '4.5rem') || (width <= 453 && '6rem')
                                    }}>
                                        <Label htmlFor="label" style={{ textAlign: 'left' }}>
                                            ¿Paga día 31 para ausentismos?
                                            (No aplica licencias remuneradas y no remuneradas)
                                        </Label>
                                        <InfoIcon msg={info[0]}
                                            element={
                                                <Dropdown className="dd" value={ausentismos} disabled={!canEditConf}
                                                    tooltip={ausentismos?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }} autoFocus
                                                    filter showClear filterBy="description"
                                                    options={listaAusentismos} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setAusentimos(e.value)}
                                                    placeholder={ausentismos ? ausentismos.description : "Seleccione"}
                                                    optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup style={{ marginTop: width > 961 ? '-1.8rem' : '-0.5rem' }}>
                                        <Label htmlFor="label">Tipo pago enfermedad general</Label>
                                        <InfoIcon msg={info[1]}
                                            element={
                                                <Dropdown className="dd" value={tipoPagoEnfermedad} disabled={!canEditConf}
                                                    tooltip={tipoPagoEnfermedad?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaTipoPagoEnfermedad} emptyMessage={"No hay tipos disponibles"}
                                                    onChange={(e) => setTipoPagoEnfermedad(e.value)}
                                                    placeholder={tipoPagoEnfermedad ? tipoPagoEnfermedad.description : "Seleccione"}
                                                    optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Porcentaje de Cotización a pensión en LNR</Label>
                                        <InfoIcon msg={info[12]}
                                            element={
                                                <Dropdown className="dd" value={cotizacion} disabled={!canEditConf}
                                                    tooltip={cotizacion?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaCotizacion} emptyMessage={"No hay porcentajes disponibles"}
                                                    onChange={(e) => setCotizacion(e.value)}
                                                    placeholder={cotizacion ? cotizacion.description : "Seleccione"}
                                                    optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <Card title="Configuración vacaciones" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">¿Paga el día 31?</Label>
                                        <InfoIcon msg={info[2]}
                                            element={
                                                <Dropdown className="dd" value={vacaciones} disabled={!canEditConf}
                                                    tooltip={vacaciones?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaVacaciones} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setVacaciones(e.value)}
                                                    placeholder={vacaciones ? vacaciones.description : "Seleccione"}
                                                    optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Cálculo variable</Label>
                                        <InfoIcon msg={info[3]}
                                            element={
                                                <Dropdown className="dd" value={variableVacaciones} disabled={!canEditConf}
                                                    tooltip={variableVacaciones?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaVariableVacaciones} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setVariableVacaciones(e.value)}
                                                    placeholder={variableVacaciones ? variableVacaciones.description : "Seleccione"}
                                                    optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <Card title="Prestaciones de ley" style={cardStyle}>
                                <div style={{ textAlign: "left", marginLeft: '1.5rem' }} className="mb-3 font-bold text-4xl">
                                    <span className="text-800" style={{
                                        fontSize: "18px",
                                        marginLeft: width < 962 && '1rem'
                                    }}>
                                        Prima
                                    </span>
                                </div>
                                <Div>
                                    <FormGroup
                                        style={{
                                            marginTop: width > 961 && width < 1192 && '-3rem',
                                            marginBottom: width <= 576 && '4rem'
                                        }}
                                    >
                                        <Label htmlFor="label" style={{ textAlign: 'left' }}>
                                            ¿Se tienen en cuenta las SLN en cáculo prima (unidades)?
                                        </Label>
                                        <InfoIcon msg={info[4]}
                                            element={
                                                <Dropdown className="dd" value={slnPrima} disabled={!canEditConf}
                                                    tooltip={slnPrima?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaSlnPrima} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setSlnPrima(e.value)}
                                                    placeholder={slnPrima ? slnPrima.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup className='resp2'>
                                        <Label htmlFor="label">Auxilio de transporte</Label>
                                        <InfoIcon msg={info[5]}
                                            element={
                                                <Dropdown className="dd" value={auxilioTransporte} disabled={!canEditConf}
                                                    tooltip={auxilioTransporte?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description" emptyMessage={"No hay opciones disponibles"}
                                                    options={listaAuxilioTransporte}
                                                    onChange={(e) => setAuxilioTransporte(e.value)}
                                                    placeholder={auxilioTransporte ? auxilioTransporte.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Pago prima junio</Label>
                                        <InfoIcon msg={info[6]}
                                            element={
                                                <Dropdown className="dd" value={primaJunio} disabled={!canEditConf}
                                                    tooltip={primaJunio?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaPrimaJunio} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setPrimaJunio(e.value)}
                                                    placeholder={primaJunio ? primaJunio.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Pago prima diciembre</Label>
                                        <InfoIcon msg={info[7]}
                                            element={
                                                <Dropdown className="dd" value={primaDiciembre} disabled={!canEditConf}
                                                    tooltip={primaDiciembre?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaPrimaDiciembre} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setPrimaDiciembre(e.value)}
                                                    placeholder={primaDiciembre ? primaDiciembre.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <div style={{ textAlign: "left" }} className="mb-2 font-bold text-4xl">
                                            <span className="text-800" style={{ fontSize: "18px" }}>Interéses</span>
                                        </div>
                                        <Label htmlFor="label">Pago intereses de cesantías</Label>
                                        <InfoIcon msg={info[8]}
                                            element={
                                                <Dropdown className="dd" value={interesesCesantias} disabled={!canEditConf}
                                                    tooltip={interesesCesantias?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaInteresesCesantias} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setInteresesCesantias(e.value)}
                                                    placeholder={interesesCesantias ? interesesCesantias.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup style={{
                                        marginTop: width < 962 && '3rem'
                                    }}>
                                        <div style={{ textAlign: "left" }} className="mb-2 font-bold text-4xl">
                                            <span className="text-800" style={{ fontSize: "18px" }}>Nomina electrónica</span>
                                        </div>
                                        <Label htmlFor="label">¿Cómo se reportan las prestaciones de ley?</Label>
                                        <InfoIcon msg={info[14]}
                                            element={
                                                <Dropdown className="dd" value={nominaElectronica} disabled={!canEditConf}
                                                    tooltip={nominaElectronica?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaNominaElectronica} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setNominaElectronica(e.value)}
                                                    placeholder={nominaElectronica.detail_id ? nominaElectronica.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <div style={{ textAlign: "left", marginLeft: '1.5rem' }} className="mb-3 mt-6 font-bold text-4xl">
                                    <span className="text-800" style={{
                                        fontSize: "18px",
                                        marginLeft: width < 962 && '1rem'
                                    }}>
                                        Cesantías
                                    </span>
                                </div>
                                <Div>
                                    <FormGroup >
                                        <Label htmlFor="label">Auxilio de transporte</Label>
                                        <InfoIcon msg={info[9]}
                                            element={
                                                <Dropdown className="dd" value={auxilioCesantias} disabled={!canEditConf}
                                                    tooltip={auxilioCesantias?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaAuxilioCesantias} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => { setAuxilioCesantias(e.value) }}
                                                    placeholder={auxilioCesantias ? auxilioCesantias.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <Card title="Descuento de ley" style={cardStyle}>
                                <Div className='mt-7'>
                                    <FormGroup
                                        style={{
                                            marginTop: width > 961 ? "-4.5rem" : '-3rem',
                                            marginBottom: (width < 813 && width > 453 && '4.5rem') || (width <= 453 && '6rem')
                                        }}
                                    >
                                        <Label htmlFor="label" style={{ textAlign: 'left' }}>
                                            ¿Cuál es la periodicidad de descuento de Solidaridad y Subsistencia?
                                        </Label>
                                        <InfoIcon msg={info[15]}
                                            element={
                                                <Dropdown className="dd" value={solidaridad} disabled={!canEditConf}
                                                    tooltip={solidaridad?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaSolidaridad} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setSolidaridad(e.value)}
                                                    placeholder={solidaridad ? solidaridad.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup className='resp2' style={{
                                        marginTop: width > 961 ? "-4.5rem" : '2rem',
                                        marginBottom: (width < 813 && width > 453 && '4.5rem') || (width <= 453 && '6rem')
                                    }}>
                                        <Label htmlFor="label" style={{ textAlign: 'left' }}>¿Cuál es la periodicidad de descuento de Retención en la fuente?</Label>
                                        <InfoIcon msg={info[16]}
                                            element={
                                                <Dropdown className="dd" value={retefuente} disabled={!canEditConf}
                                                    tooltip={retefuente?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description" emptyMessage={"No hay opciones disponibles"}
                                                    options={listaRetefuente}
                                                    onChange={(e) => setRetefuente(e.value)}
                                                    placeholder={retefuente ? retefuente.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <Card title="Subsidio de transporte" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">¿Cual es la periodicidad de pago?</Label>
                                        <InfoIcon msg={info[10]}
                                            element={
                                                <Dropdown className="dd" value={pagoSubsidioTransporte} disabled={!canEditConf}
                                                    tooltip={pagoSubsidioTransporte?.description} tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                    filter showClear filterBy="description"
                                                    options={listaPagoSubsidioTransporte} emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => setPagoSubsidioTransporte(e.value)}
                                                    placeholder={pagoSubsidioTransporte ? pagoSubsidioTransporte.description : "Seleccione"} optionLabel='description'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <div className="card mt-4">
                                    <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
                                    <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                                        selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="CONCEPT"
                                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONCEPT', 'NAME', 'TYPE']}
                                        header={header1} >
                                        <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                                        <Column field="CONCEPT" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por concepto" sortable></Column>
                                        <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                                        <Column field="TYPE" header="Tipo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                                        <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                                    </DataTable>
                                </div>
                            </Card>
                            <Button label='Guardar' loading={loading3} className='text-lg' type="submit" disabled={!validateForm() || !canEditConf} onClick={() => { setLoading3(true); putPayroll() }} />
                        </Forms>
                    </div>
                </SkeletonTable>
            </Form>
        </div>
    );
}